import { useCallback, useState } from "react";
import { useBoolean } from "@/ui-kit";
import type { IServiceArea } from "@/types/common";
import { InspectorsRepository } from "@/api/inspectors/repository";
import { InspectorsService } from "@/api/inspectors/service";
import { ServiceAreasCard } from "@/components/profile-cards";
import { ServiceAreasEditModal } from "@/components/profile-forms/ServiceAreasForm";

type IProps = {
  userId: number;
  serviceAreas: IServiceArea[];
};

export const ServiceAreas = ({ userId, serviceAreas }: IProps) => {
  const [values, setValues] = useState<IServiceArea[]>(serviceAreas);

  const {
    value: showEditModal,
    setTrue: openEditModal,
    setFalse: dismissEditModal,
  } = useBoolean(false);

  const updateValues = useCallback((v: IServiceArea[]) => {
    setValues(v);
  }, []);

  const updateServiceArea = useCallback(
    (params: { userId: number; serviceAreas: IServiceArea[] }) => {
      const inspectorsRepository = new InspectorsRepository(
        new InspectorsService(),
      );
      return inspectorsRepository.updateInspectorServiceArea(params);
    },
    [],
  );

  return (
    <>
      <ServiceAreasCard serviceAreas={values} onEdit={openEditModal} />
      {showEditModal && (
        <ServiceAreasEditModal
          userId={userId}
          serviceAreas={values}
          updateServiceArea={updateServiceArea}
          onSave={updateValues}
          onDismiss={dismissEditModal}
        />
      )}
    </>
  );
};
